const reportedErrors = new WeakSet();

/** A rejected input or expired account state, rather than a technical failure. */
export class ExpectedStorefrontError extends Error {}

export function storefrontResponseError(response, message, expectedStatuses = []) {
    const ErrorType = expectedStatuses.includes(response.status) ? ExpectedStorefrontError : Error;
    const error = new ErrorType(message);
    error.orderDiagnostics = { status: response.status };
    return error;
}

export function reportCaughtStorefrontError(error, stage, details = {}, signal) {
    if (
        error instanceof ExpectedStorefrontError ||
        error?.name === 'AbortError' ||
        signal?.aborted ||
        window.clientRuntimePageUnloading
    )
        return;
    reportClientRuntimeError(error, stage, details);
}

export function createClientRuntimeDiagnosticId() {
    try {
        return [...window.crypto.getRandomValues(new Uint8Array(16))]
            .map((value) => value.toString(16).padStart(2, '0'))
            .join('');
    } catch {
        return '';
    }
}

/** Retain caught errors through the existing lazy monitor without changing recovery. */
export function reportClientRuntimeError(error, stage, details = {}) {
    try {
        const failure = error instanceof Error ? error : new Error(String(error));
        if (reportedErrors.has(failure)) return;
        try {
            failure.orderDiagnostics = { ...failure.orderDiagnostics, ...details, route: stage };
        } catch {
            // Frozen errors can still be reported with their original stack.
        }
        if (typeof window.clientRuntime?.captureException === 'function') {
            window.clientRuntime.captureException(failure);
            reportedErrors.add(failure);
        } else {
            window.clientRuntimeQueue ||= [];
            if (window.clientRuntimeQueue.length < 20) {
                window.clientRuntimeQueue.push({ error: failure });
                reportedErrors.add(failure);
            }
            window.clientRuntimeLoad?.();
        }
    } catch {
        // Monitoring failures must not change the confirmed order or optional UI.
    }
}
